export const raf = () => new Promise<void>((r) => requestAnimationFrame(() => r()));
export const idle = (ms = 0) =>
  new Promise<void>((resolve) => {
    const ric = (window as unknown as { requestIdleCallback?: (cb: () => void, opts?: { timeout?: number }) => number })
      .requestIdleCallback;
    if (typeof ric === 'function') ric(() => resolve(), { timeout: ms || 200 });
    else setTimeout(resolve, ms || 0);
  });

export interface Cancellable {
  cancel(): void;
}

export function debounce<T extends (...args: any[]) => void>(fn: T, wait = 120) {
  let t: any;
  const debounced = (...args: Parameters<T>) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), wait);
  };
  return Object.assign(debounced, { cancel: () => clearTimeout(t) }) as ((...args: Parameters<T>) => void) &
    Cancellable;
}
export function throttle<T extends (...args: any[]) => void>(fn: T, ms = 120) {
  let last = 0;
  let timer: any = null;
  let pending: Parameters<T> | null = null;
  const run = () => {
    last = Date.now();
    timer = null;
    const args = pending;
    pending = null;
    if (args) fn(...args);
  };
  const throttled = (...args: Parameters<T>) => {
    pending = args;
    const now = Date.now();
    if (!timer) {
      const wait = Math.max(0, ms - (now - last));
      timer = setTimeout(run, wait);
    }
  };
  const cancel = () => {
    clearTimeout(timer);
    timer = null;
    pending = null;
  };
  return Object.assign(throttled, { cancel }) as ((...args: Parameters<T>) => void) & Cancellable;
}
